import DataTableView from "@components/views/datatable-view";
import usePageChange from "@hooks/use-page-change";
import useChildCompanies from "./use-child-companies";

export const ChildComapnies = () => {
    const {
        data: { childCompanies = [], pagination = {} },
        loading,
        columns,
        setQueryParams
    } = useChildCompanies();

    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });
    return (
        <div className="mt-1">
            <DataTableView
                moduleName={"Child Companies"}
                loading={loading}
                tableProps={{
                    data: childCompanies,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination
                }}/>
        </div>
    );
};
